import React from 'react';
import * as L from 'lucide-react';

/**
 * Icon lookup wrapper. Maps prototype's kebab-case names
 * ("chevron-right") to Lucide-React PascalCase exports ("ChevronRight").
 *
 * @param {{ name: string, size?: number, color?: string, className?: string }} props
 */
export default function Icon({ name, size = 16, color, className }) {
  if (!name) return null;
  const pascal = name
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
  /** @type {Record<string, any>} */
  const icons = L;
  const Component = icons[pascal];
  if (!Component) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`Icon: lucide-react has no export "${pascal}" (from name "${name}")`);
    }
    return null;
  }
  return <Component size={size} color={color} className={className} aria-hidden="true" />;
}
